import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_HANDOVERLIST,
  DELETE_HANDOVERLIST,
  UPDATE_HANDOVERLIST,
  ADD_NEW_HANDOVERLIST,
} from "./actionType";

import {
  getHandoverListSuccess,
  getHandoverListFail,
  deleteHandoverListSuccess,
  deleteHandoverListFail,
  updateHandoverListSuccess,
  updateHandoverListFail,
  addHandoverListSuccess,
  addHandoverListFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getHandoverListApi,
  updateHandoverListApi,
  deleteHandoverListApi,
  addNewHandoverListApi
} from "../../helpers/backend_helper";

function* getHandoverList({ payload: handoverList }) {
  try {
    const response = yield call(getHandoverListApi, handoverList);
    yield put(getHandoverListSuccess(GET_HANDOVERLIST, response.data));
  } catch (error) {
    yield put(getHandoverListFail(GET_HANDOVERLIST, error));
  }
}

function* onUpdateHandoverList({ payload: handoverList }) {
  try {
    const response = yield call(updateHandoverListApi, handoverList);
    yield put(updateHandoverListSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateHandoverListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteHandoverList({ payload: handoverList }) {
  try {
    const response = yield call(deleteHandoverListApi, handoverList);
    yield put(deleteHandoverListSuccess({ handoverList, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteHandoverListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewHandoverList({ payload: handoverList }) {
  try {
    const response = yield call(addNewHandoverListApi, handoverList);
    yield put(addHandoverListSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addHandoverListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetHandoverList() {
  yield takeEvery(GET_HANDOVERLIST, getHandoverList);
}

export function* watchUpdateHandoverList() {
  yield takeEvery(UPDATE_HANDOVERLIST, onUpdateHandoverList);
}

export function* watchDeleteHandoverList() {
  yield takeEvery(DELETE_HANDOVERLIST, onDeleteHandoverList);
}

export function* watchAddNewHandoverList() {
  yield takeEvery(ADD_NEW_HANDOVERLIST, onAddNewHandoverList);
}

function* handoverListSaga() {
  yield all([
    fork(watchGetHandoverList),
    fork(watchDeleteHandoverList),
    fork(watchUpdateHandoverList),
    fork(watchAddNewHandoverList)
  ]);
}

export default handoverListSaga;
